"use strict";

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var address_1 = require("./address");

var pagination_1 = require("./pagination");

var class_transformer_1 = require("class-transformer");

var media_1 = require("./media");

var brandPicture_1 = require("./brandPicture");

var brandDefaultType_1 = require("../enum/brandDefaultType");

var queryDecorator_1 = require("../queryDecorator");

var validationCountryCode_1 = require("../validationCountryCode");

var brandFile_1 = require("./brandFile");

var brandMarket_1 = require("../enum/brandMarket");

var BrandOrderEnum;

(function (BrandOrderEnum) {
  BrandOrderEnum["name"] = "name";
  BrandOrderEnum["enabled"] = "enabled";
  BrandOrderEnum["createdAt"] = "createdAt";
  BrandOrderEnum["updatedAt"] = "updatedAt";
  BrandOrderEnum["deletedAt"] = "deleteAt";
})(BrandOrderEnum = exports.BrandOrderEnum || (exports.BrandOrderEnum = {}));

var BrandDTO = function BrandDTO() {
  _classCallCheck(this, BrandDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], BrandDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandDTO.prototype, "alternativeNames", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), validationCountryCode_1.IsCountryCode(), __metadata("design:type", String)], BrandDTO.prototype, "madeIn", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], BrandDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], BrandDTO.prototype, "websiteUrl", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], BrandDTO.prototype, "address", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return media_1.MediaDTO;
}), __metadata("design:type", media_1.MediaDTO)], BrandDTO.prototype, "logo", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return media_1.MediaDTO;
}), __metadata("design:type", media_1.MediaDTO)], BrandDTO.prototype, "cover", void 0);

__decorate([class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return brandPicture_1.BrandPictureDTO;
}), __metadata("design:type", Array)], BrandDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandDefaultType_1.BrandDefaultType), __metadata("design:type", String)], BrandDTO.prototype, "defaultType", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandMarket_1.BrandMarket), __metadata("design:type", String)], BrandDTO.prototype, "market", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandDTO.prototype, "brandInvitationToken", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], BrandDTO.prototype, "createdAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], BrandDTO.prototype, "updatedAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], BrandDTO.prototype, "deletedAt", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandDTO.prototype, "isApproximatedDimensions", void 0);

exports.BrandDTO = BrandDTO;

var BrandSuggestionDTO = function BrandSuggestionDTO() {
  _classCallCheck(this, BrandSuggestionDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], BrandSuggestionDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandSuggestionDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandSuggestionDTO.prototype, "name", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return media_1.MediaDTO;
}), __metadata("design:type", media_1.MediaDTO)], BrandSuggestionDTO.prototype, "logo", void 0);

exports.BrandSuggestionDTO = BrandSuggestionDTO;

var BrandLightDTO = function BrandLightDTO() {
  _classCallCheck(this, BrandLightDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], BrandLightDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandLightDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandLightDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandLightDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandLightDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], BrandLightDTO.prototype, "websiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), validationCountryCode_1.IsCountryCode(), __metadata("design:type", String)], BrandLightDTO.prototype, "madeIn", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return media_1.MediaDTO;
}), __metadata("design:type", media_1.MediaDTO)], BrandLightDTO.prototype, "logo", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return media_1.MediaDTO;
}), __metadata("design:type", media_1.MediaDTO)], BrandLightDTO.prototype, "cover", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandLightDTO.prototype, "isApproximatedDimensions", void 0);

exports.BrandLightDTO = BrandLightDTO;

var BrandExtendedDTO =
/*#__PURE__*/
function (_BrandDTO) {
  _inherits(BrandExtendedDTO, _BrandDTO);

  function BrandExtendedDTO() {
    _classCallCheck(this, BrandExtendedDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrandExtendedDTO).apply(this, arguments));
  }

  return BrandExtendedDTO;
}(BrandDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], BrandExtendedDTO.prototype, "productsCount", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], BrandExtendedDTO.prototype, "productsCountWith3DFile", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], BrandExtendedDTO.prototype, "productsCountWithProblem", void 0);

exports.BrandExtendedDTO = BrandExtendedDTO;

var BrandCreationDTO = function BrandCreationDTO() {
  _classCallCheck(this, BrandCreationDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], BrandCreationDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandCreationDTO.prototype, "alternativeNames", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandCreationDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandCreationDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], BrandCreationDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], BrandCreationDTO.prototype, "websiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], BrandCreationDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], BrandCreationDTO.prototype, "logo", void 0);

__decorate([validationCountryCode_1.IsCountryCode(), class_validator_1.IsOptional(), __metadata("design:type", String)], BrandCreationDTO.prototype, "madeIn", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], BrandCreationDTO.prototype, "cover", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandCreationDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandDefaultType_1.BrandDefaultType), __metadata("design:type", String)], BrandCreationDTO.prototype, "defaultType", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandMarket_1.BrandMarket), __metadata("design:type", String)], BrandCreationDTO.prototype, "market", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandCreationDTO.prototype, "architectIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return brandPicture_1.BrandPictureCreationDTO;
}), __metadata("design:type", Array)], BrandCreationDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return brandFile_1.BrandFileCreationDTO;
}), __metadata("design:type", Array)], BrandCreationDTO.prototype, "files", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandCreationDTO.prototype, "countries", void 0);

exports.BrandCreationDTO = BrandCreationDTO;

var BrandUpdateDTO = function BrandUpdateDTO() {
  _classCallCheck(this, BrandUpdateDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandUpdateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandUpdateDTO.prototype, "alternativeNames", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], BrandUpdateDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandUpdateDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsPhoneNumber('ZZ'), __metadata("design:type", String)], BrandUpdateDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], BrandUpdateDTO.prototype, "websiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], BrandUpdateDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", Object)], BrandUpdateDTO.prototype, "logo", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", Object)], BrandUpdateDTO.prototype, "cover", void 0);

__decorate([validationCountryCode_1.IsCountryCode(), class_validator_1.IsOptional(), __metadata("design:type", String)], BrandUpdateDTO.prototype, "madeIn", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandUpdateDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandDefaultType_1.BrandDefaultType), __metadata("design:type", String)], BrandUpdateDTO.prototype, "defaultType", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(brandMarket_1.BrandMarket), __metadata("design:type", String)], BrandUpdateDTO.prototype, "market", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandUpdateDTO.prototype, "architectIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return brandPicture_1.BrandPictureCreationDTO;
}), __metadata("design:type", Array)], BrandUpdateDTO.prototype, "pictures", void 0);

exports.BrandUpdateDTO = BrandUpdateDTO;

var BrandFilterDTO = function BrandFilterDTO() {
  _classCallCheck(this, BrandFilterDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandFilterDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], BrandFilterDTO.prototype, "query", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), queryDecorator_1.TransformToBoolean(), __metadata("design:type", Boolean)], BrandFilterDTO.prototype, "promoted", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), validationCountryCode_1.IsCountryCode({
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "madeIn", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "accountIds", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandFilterDTO.prototype, "enabled", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandFilterDTO.prototype, "deleted", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandFilterDTO.prototype, "onlyVisible", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], BrandFilterDTO.prototype, "haveProducts", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "brandIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "architectIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsEnum(brandMarket_1.BrandMarket, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "markets", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], BrandFilterDTO.prototype, "priceMin", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], BrandFilterDTO.prototype, "priceMax", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "objectProductCategoryIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "designerIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "styleTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "roomTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "colorTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandFilterDTO.prototype, "materialTagIds", void 0);

exports.BrandFilterDTO = BrandFilterDTO;

var BrandLexique = function BrandLexique() {
  _classCallCheck(this, BrandLexique);
};

exports.BrandLexique = BrandLexique;

var BrandPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(BrandPaginationResponse, _pagination_1$Paginat);

  function BrandPaginationResponse() {
    _classCallCheck(this, BrandPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(BrandPaginationResponse).apply(this, arguments));
  }

  return BrandPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([pagination_1.PaginationData(BrandExtendedDTO), __metadata("design:type", Array)], BrandPaginationResponse.prototype, "data", void 0);

exports.BrandPaginationResponse = BrandPaginationResponse;

var BrandArchitectCreationDTO = function BrandArchitectCreationDTO() {
  _classCallCheck(this, BrandArchitectCreationDTO);
};

__decorate([class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], BrandArchitectCreationDTO.prototype, "architectIds", void 0);

exports.BrandArchitectCreationDTO = BrandArchitectCreationDTO;